module.exports = __webpack_public_path__ + "img/gift4.14f7e5e9.png";